import type { ComponentType } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getAdminModuleById } from '@/config/adminModules';
import { routes } from '@/config/routes';
import { adminModuleComponents } from '@/pages/Admin/adminModuleRegistry';
import { AdminPlaceholderPage } from '@/pages/Admin/modules/AdminPlaceholderPage';

export function AdminModuleEmbedPage() {
  const { moduleId = '' } = useParams<{ moduleId: string }>();
  const moduleDefinition = getAdminModuleById(moduleId);

  if (!moduleDefinition) {
    return <Navigate to={routes.admin} replace />;
  }

  const ModuleComponent: ComponentType | undefined =
    adminModuleComponents[moduleId];

  if (ModuleComponent) {
    return <ModuleComponent />;
  }

  return <AdminPlaceholderPage moduleId={moduleId} />;
}
